import type { TrackingEvent } from '@marketplace-web/shared/event-tracker-data'

type viewShippingPriceEventArgs = {
  prices: Array<string>
  screen: string
  itemId?: number
  transactionId?: number
}

type ViewShippingPriceEventExtra = {
  prices: Array<string> | null
  screen: string
  item_id?: number
  transaction_id?: number
}

export const viewShippingPriceEvent = (args: viewShippingPriceEventArgs): TrackingEvent => {
  const { prices, screen, itemId, transactionId } = args

  const extra: ViewShippingPriceEventExtra = {
    prices: prices.length ? prices : null,
    screen,
  }

  if (itemId) extra.item_id = itemId
  if (transactionId) extra.transaction_id = transactionId

  return {
    event: 'user.view_shipping_price',
    extra,
  }
}
